<ng-container *ngIf="form && controlName">
  <mat-form-field [style.width]="width" [formGroup]="form">
    <mat-label>{{ label }}</mat-label>
    <input matInput [ngModel]="form.get(controlName)?.value" [ngModelOptions]="{ standalone: true }" />
    <ngx-colors class="color-picker" matSuffix style="display: inline-block; margin: 5px" ngx-colors-trigger
      [formControlName]="controlName" (change)="onChange($event)"></ngx-colors>
  </mat-form-field>
</ng-container>

<ng-container *ngIf="abstractControl && controlName">
  <mat-form-field [style.width]="width">
    <mat-label>{{ label }}</mat-label>
    <input matInput [ngModel]="abstractControl.get(controlName)?.value" [ngModelOptions]="{ standalone: true }" />
    <ngx-colors class="color-picker" matSuffix style="display: inline-block; margin: 5px" ngx-colors-trigger
      [ngModel]="abstractControl.get(controlName)?.value" [ngModelOptions]="{ standalone: true }"
      (change)="onChange($event)"></ngx-colors>
  </mat-form-field>
</ng-container>